import { render, staticRenderFns } from "./CommissionRateAdjustmentRuleSetList.vue?vue&type=template&id=07480212"
import script from "./CommissionRateAdjustmentRuleSetList.vue?vue&type=script&lang=js"
export * from "./CommissionRateAdjustmentRuleSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports